"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFullName = void 0;
const createFullName = (firstName, lastName) => [lastName, firstName]
    .filter((x) => !!x)
    .map(x => x.trim())
    .filter(x => x)
    .join(' ');
exports.createFullName = createFullName;
//# sourceMappingURL=fullName.js.map